var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',{class:_vm.iconClassList,attrs:{"data-class":"base-icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }